import TR from 'utils/TR';
import T from 'utils/T';
import * as Luxon from 'luxon'
import { decrypt_aes, encrypt_aes, encrypt_rsa } from 'utils/crypto';

window.NB_COMMUNICATION_LOG = +(window.localStorage.getItem('NB_COMMUNICATION_LOG') || 0);

export const apis = {
  'V100/doctors/login': ['post', { path: 'V100/doctors/login', targets: ['global', 'communication'], message: T('의료진 로그인') }],
  'V100/doctors/logout': ['delete', { path: 'V100/doctors/logout', targets: ['global', 'communication'], message: T('의료진 로그아웃') }],
  'V100/doctors/pwd-chg': ['put', { path: 'V100/doctors/pwd-chg', targets: ['global', 'communication'], message: T('의료진 비밀번호 변경') }],
  'V100/doctors/info': ['get', { path: 'V100/doctors/info', targets: ['global', 'communication'], message: T('의료진 정보 조회') }],
  'V100/doctors/patients': ['get', { path: 'V100/doctors/patients', targets: ['global', 'communication'], message: T('의료진 정보 조회') }],
  'V100/doctors/patients-detail': ['get', { path: 'V100/doctors/patients-detail', targets: ['global', 'communication'], message: T('의료진 정보 조회') }],
  'V100/doctors/agp/graph': ['get', { path: 'V100/doctors/agp/graph', targets: ['global', 'communication'], message: T('의료진 정보 조회') }],
  'V100/dashboard': ['get', { path: 'V100/dashboard', targets: ['global', 'communication'], message: T('대시보드 조회') }],
  'V100/report/blood-sugar': ['post', { path: 'V100/report/blood-sugar', targets: ['global', 'communication'], message: T('분석보고서 혈당 조회') }],
  'V100/report/abnormal-blood-sugar': ['post', { path: 'V100/report/abnormal-blood-sugar', targets: ['global', 'communication'], message: T('분석보고서 혈당 이상혈당조회') }],
  'V100/report/active/step': ['get', { path: 'V100/report/active/step', targets: ['global', 'communication'], message: T('분석보고서 활동 조회') }],
  'V100/report/active/step/cal': ['get', { path: 'V100/report/active/step/cal', targets: ['global', 'communication'], message: T('분석보고서 활동 조회') }],
  'V100/report/active/stat-day-graph': ['get', { path: 'V100/report/active/stat-day-graph', targets: ['global', 'communication'], message: T('분석보고서 활동 일별통계조회') }],
  'V100/report/active/stat-day-list': ['get', { path: 'V100/report/active/stat-day-list', targets: ['global', 'communication'], message: T('분석보고서 활동 일별통계조회') }],

  'V100/doctor/dr-guide/list': ['get', { path: 'V100/doctor/dr-guide/list', targets: ['global', 'communication'], message: T('닥터가이드 목록조회') }],
  'V100/doctor/dr-guide': ['get', { path: 'V100/doctor/dr-guide', targets: ['global', 'communication'], message: T('닥터가이드 조회') }],
  'V100/doctor/dr-guide/save': ['post', { path: 'V100/doctor/dr-guide/save', targets: ['global', 'communication'], message: T('닥터가이드 저장') }],
  'V100/doctor/dr-guide/delete': ['delete', { path: 'V100/doctor/dr-guide/delete', targets: ['global', 'communication'], message: T('닥터가이드 삭제') }],

  'V100/report/meal': ['get', { path: 'V100/report/meal', targets: ['global', 'communication'], message: T('분석보고서 식사 조회') }],
  'V100/report/meal/analysis': ['post', { path: 'V100/report/meal/analysis', targets: ['global', 'communication'], message: T('분석보고서 식사별 분석 조회') }],
  'V100/report/food/analysis': ['post', { path: 'V100/report/food/analysis', targets: ['global', 'communication'], message: T('분석보고서 음식식사 분석 조회') }],
  'V100/report/meal/daily': ['get', { path: 'V100/report/meal/daily', targets: ['global', 'communication'], message: T('분석보고서 일별식사 조회') }],
  'V100/report/meal/daily-graph': ['get', { path: 'V100/report/meal/daily-graph', targets: ['global', 'communication'], message: T('분석보고서 일별식사 그래프 조회') }],
  'V100/report/insulin': ['get', { path: 'V100/report/insulin', targets: ['global', 'communication'], message: T('분석보고서 인슐린 조회') }],
  'V100/report/bolus': ['post', { path: 'V100/report/bolus', targets: ['global', 'communication'], message: T('분석보고서 인슐린 볼루스 조회') }],
  'V100/report/insulin/pattern': ['get', { path: 'V100/report/insulin/pattern', targets: ['global', 'communication'], message: T('분석보고서 인슐린 패턴') }],
  'V100/report/insulin/stats': ['get', { path: 'V100/report/insulin/stats', targets: ['global', 'communication'], message: T('분석보고서 인슐린 통계') }],
  'V100/report/insulin/stats-graph': ['get', { path: 'V100/report/insulin/stats-graph', targets: ['global', 'communication'], message: T('분석보고서 인슐린 통계') }],

  'V100/pop-up/bldsugr': ['get', { path: 'V100/pop-up/bldsugr', targets: ['global', 'communication'], message: T('이벤트 시점 팝업데이터 조회') }],
  'V100/pop-up/active': ['get', { path: 'V100/pop-up/active', targets: ['global', 'communication'], message: T('일일활동 팝업데이터 조회') }],
  'V100/bldsugr/exist/date': ['get', { path: 'V100/bldsugr/exist/date', targets: ['global', 'communication'], message: T('혈당 데이터 존재 일자(여부) 조회') }],

  'V100/simulation/agp/graph': ['post', { path: 'V100/simulation/agp/graph', targets: ['global', 'communication'], message: T('AI시뮬레이션 AGP조회') }],
  'V100/simulation/active': ['get', { path: 'V100/simulation/active', targets: ['global', 'communication'], message: T('AI시뮬레이션 활동 조회') }],
  'V100/simulation/active/result': ['post', { path: 'V100/simulation/active/result', targets: ['global', 'communication'], message: T('AI시뮬레이션 활동 실행') }],
  'V100/simulation/insulin': ['get', { path: 'V100/simulation/insulin', targets: ['global', 'communication'], message: T('AI시뮬레이션 인슐린 조회') }],
  'V100/simulation/insulin/result': ['post', { path: 'V100/simulation/insulin/result', targets: ['global', 'communication'], message: T('AI시뮬레이션 인슐린 실행') }],
  'V100/simulation/meal': ['get', { path: 'V100/simulation/meal', targets: ['global', 'communication'], message: T('AI시뮬레이션 식사 조회') }],
  'V100/simulation/meal/result': ['post', { path: 'V100/simulation/meal/result', targets: ['global', 'communication'], message: T('AI시뮬레이션 식사 실행') }],

  'V100/report/meal/detail': ['get', { path: 'V100/report/meal/detail', targets: ['global', 'communication'], message: T('식사정보 상세조회') }],
  'V100/insulin/recommend/injection': ['get', { path: 'V100/insulin/recommend/injection', targets: ['global', 'communication'], message: T('인슐린 권장 투여량 조회') }],
};

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  // 'Access-Control-Allow-Credentials': 'true',
};

const uploadHeaders = {
  'Accept': 'application/json',
};

export default async function RestAPIFetch(
  id,
  host,
  args,
  options,
  events,
) {
  try {
    const {
      parameters,
      // credentials = 'include',
      credentials,
      headers: hs = {},
    } = args;

    const {
      upload = false,
      download = false,
      timeout,
      access_token,
      timestamp,
      headers: ohs,
      secure = null,
    } = options;

    const {
      onReceive,
      onCatch,
      onExpire,
      onStart,
      onEnd,
    } = events || {};


    const secureHeaders = !secure ? {} : {
      'portal-hash': secure.hash,
      'portal-key': await encrypt_rsa(secure.aes + ':' + secure.timestamp + ':' + secure.iv, secure.key),
    };

    if (access_token) hs['Authorization'] = `Bearer ${access_token}`;
    const headers =
      upload ?
        { ...uploadHeaders, ...hs, ...ohs, ...secureHeaders } :
        download ?
          { ...hs, ...secureHeaders } :
          { ...defaultHeaders, ...hs, ...ohs, ...secureHeaders };
    const api = apis[id];
    if (!api) {
      throw new Error(['RestAPI', 'API not exist', id].join(' : '))
    } else {
      const { path, targets, message } = api[1];

      const controller = new AbortController();
      const signal = controller.signal;
      const abort = (reason) => controller.abort(reason);
      const start = Date.now();
      onStart && onStart(id, abort, targets, message);
      const timeoutId = timeout ? setTimeout(() => {
        if (!onExpire) return;
        if (onExpire(abort)) {
          const end = Date.now();
          if (window.NB_COMMUNICATION_LOG) console.log(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][EXPIRE]', [Luxon.DateTime.fromMillis(start).toFormat('(HH:mm:ss.SSS)'), method, path].join(' '), { parameters, headers }, '<ELASPED', end - start, 'ms>');
          onEnd && onEnd();
        }
      }, timeout) : 0;

      const method = api[0].toLowerCase();

      if (window.NB_COMMUNICATION_LOG) console.log(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][REQUEST]', message, [method, path].join(' '), { parameters, headers }, '<QUEUE ELASPED', start - timestamp, 'ms>');

      switch (method) {
        case 'get': case 'delete': {
          const params = new URLSearchParams();
          Object.keys(parameters || {}).forEach(key => {
            const value = parameters[key];
            if (value instanceof Array) {
              value.forEach(v => {
                if (secure) {
                  params.append(key, encrypt_aes(v, secure.aes, secure.iv));
                } else {
                  params.append(key, v);
                }
              });
            } else {
              if (secure) {
                params.append(key, encrypt_aes(value, secure.aes, secure.iv));
              } else {
                params.append(key, value);
              }
            }
          });
          return await fetch(host + '/' + path + (parameters ? '?' + params : ''), {
            mode: 'cors',
            method,
            signal,
            headers,
            credentials,
          })
            .then(res => {
              clearTimeout(timeoutId);
              const contentType = res.headers.get('Content-Type');
              onEnd && onEnd();
              return (!contentType || contentType.indexOf('application/json') < 0) ? res : res.json();
            })
            .then(res => {
              const end = Date.now();
              if (window.NB_COMMUNICATION_LOG) console.log(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][RESPONSE]', [Luxon.DateTime.fromMillis(start).toFormat('(HH:mm:ss.SSS)'), method, path].join(' '), { parameters, headers }, '=>', res, '<ELASPED', end - start, 'ms>');
              if (secure) {
                const response = res.data ? decrypt_aes(res.data, secure.aes, secure.iv) : null;
                onReceive && onReceive({
                  ...res,
                  ...(response ? { data: JSON.parse(response) } : {}),
                });
              } else {
                onReceive && onReceive(res);
              }
            })
            .catch(err => {
              clearTimeout(timeoutId);
              const end = Date.now();
              if (window.NB_COMMUNICATION_LOG) console.error(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][CATCH]', [Luxon.DateTime.fromMillis(start).toFormat('(HH:mm:ss.SSS)'), method, path].join(' '), { parameters, headers }, '=>', err, '<ELASPED', end - start, 'ms>');
              onCatch && onCatch(err);
            });
        }
        case 'patch': case 'post': case 'put': {
          let body;
          if (upload) {
            body = new FormData();
            Object.keys(parameters || {}).forEach(key => {
              if (parameters[key] instanceof Array) {
                parameters[key].forEach(item => {
                  body.append(key, item.blob, item.file_name);
                })
              } else {
                if (secure) {
                  body.append(key, encrypt_aes(parameters[key], secure.aes, secure.iv));
                } else {
                  body.append(key, parameters[key]);
                }
              }
            });
          } else {
            if (secure) {
              body = JSON.stringify({
                data: encrypt_aes(JSON.stringify(parameters || {}), secure.aes, secure.iv),
              });
            } else {
              body = JSON.stringify(parameters || {})
            }
          }
          return await fetch(host + '/' + path, {
            method,
            signal,
            body,
            headers,
            credentials,
          })
            .then(res => {
              clearTimeout(timeoutId);
              const contentType = res.headers.get('Content-Type');
              onEnd && onEnd();
              return (!contentType || contentType.indexOf('application/json') < 0) ? res : res.json();
            })
            .then(res => {
              const end = Date.now();
              if (window.NB_COMMUNICATION_LOG) console.log(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][RESPONSE]', [Luxon.DateTime.fromMillis(start).toFormat('(HH:mm:ss.SSS)'), method, path].join(' '), { parameters, headers }, '=>', res, '<ELASPED', end - start, 'ms>');
              if (secure) {
                const response = res.data ? decrypt_aes(res.data, secure.aes, secure.iv) : null;
                onReceive && onReceive({
                  ...res,
                  ...(response ? { data: JSON.parse(response) } : {}),
                });
              } else {
                onReceive && onReceive(res);
              }
            })
            .catch(err => {
              clearTimeout(timeoutId);
              const end = Date.now();
              if (window.NB_COMMUNICATION_LOG) console.error(Luxon.DateTime.now().toFormat('HH:mm:ss.SSS'), '[COMMUNICATION][CATCH]', [Luxon.DateTime.fromMillis(start).toFormat('(HH:mm:ss.SSS)'), method, path].join(' '), { parameters, headers }, '=>', err, '<ELASPED', end - start, 'ms>');
              onCatch && onCatch(err);
            });
        }
        default: {
          throw new Error(['RestAPI', 'Unknown method', method].join(' : '))
        }
      }
    }
  } catch (e) {
    throw new Error(['RestAPI', 'Exception', e].join(' : '))
  }
};
